// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';

export const AccountContainerDynamic = dynamic(() =>
  import('./AccountContainer').then(module => module.AccountContainerEditable)
);
export { AccountContainerEditable } from './AccountContainer';
